import limeBrainsVideoMp4 from '../../videos/io_limebrains-header.mp4'

export const LimeBrainsVideoMp4 = limeBrainsVideoMp4
